<template>
  <div class="parameterConfiguration">
    <div class="ledgerFieldDiv">
      <div class="basicParameters">
        <a-button class="saveBtn" type="primary" :loading="btnLoading" @click="handleSubmit" v-if="$auth('deviceType.ledgerFieldSave')">保存</a-button>
        <div class="titleDiv">
          <div class="title">设备基础信息字段</div>
          <div class="upOrDownIcon">
            <img src="../../../assets/icon_up.png" alt="" v-if="unfold" @click="unfold = !unfold">
            <img src="../../../assets/icon_down.png" alt="" v-if="!unfold" @click="unfold = !unfold">
          </div>
          <a-button type="primary" @click="whetherToSelectAll(true)" class="checkAll">全选</a-button>
          <a-button @click="whetherToSelectAll(false)" class="deselectAll">取消全选</a-button>
        </div>
        <a-spin :spinning="spinLoading">
          <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange" class="ant-checkbox-group-height" :class="[unfold ? 'height100' : '' ]"/>
        </a-spin>
      </div>
      <div class="otherParameters2">
        <div class="titleDiv">
          <div class="title">参数特性字段</div>
        </div>
        <div class="other-data">
          <a-row :gutter="10" class="item-label">
            <a-col :span="8" class="fontWeight">类型</a-col>
            <a-col :span="8" class="fontWeight">参数/特性</a-col>
            <a-col :span="8" class="fontWeight">字段</a-col>
          </a-row>
          <div class="dataInputDiv">
            <a-row v-for="(item, index) in parameterCharacteristicsList" :key="index" :gutter="10" class="item-data">
              <a-col :span="8">
                <a-select v-model="item.type" placeholder="请输入类型" style="width: 100%" @change="changeType(item, index)">
                  <a-select-option v-for="(item2, index2) in typeList" :key="index2" :value="item2.value">
                    {{ item2.label }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="8">
                <!--                基础参数-->
                <a-select v-model="item.paramOrFeature" placeholder="请选择参数/特性" style="width: 100%" @change="value => changeFeature(value, item, index)" v-if="item.type === 2">
                  <a-select-option v-for="(item2, index2) in fieldListData.paramList" :key="index2" :value="index2">
                    {{ item2.typeName }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select style="width: 100%" v-else-if="item.type === 3" disabled>
                </a-select>
                <!--                特性-->
                <a-select v-model="item.paramOrFeature" placeholder="请选择参数/特性" style="width: 100%" v-else-if="item.type === 4" @change="value => changeParamOrFeature(value,item)">
                  <a-select-option v-for="(item2, index2) in fieldListData.peculiarityList" :key="index2" :value="item2.id">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                默认-->
                <a-select style="width: 100%" v-else disabled>
                </a-select>
              </a-col>
              <a-col :span="8">
                <!--                基础参数-->
                <a-select
                  v-model="item.field"
                  placeholder="请选择字段"
                  style="width: 100%"
                  v-if="item.type === 2"
                  @change="value => changeField(value,item)"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                  <a-select-option v-for="(item2, index2) in item.fieldList" :key="index2" :value="item2.fieldId" :disabled="item2.disabled">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select v-model="item.field" placeholder="请选择字段" style="width: 100%" v-else-if="item.type === 3">
                  <a-select-option v-for="(item2, index2) in fieldListData.typeParamList" :key="index2" :value="item2.id">
                    {{ item2.name }}
                  </a-select-option>
                </a-select>
                <!--                自定义参数-->
                <a-select v-model="item.field" style="width: 100%" v-else disabled>
                </a-select>
                <a-icon type="close-square" theme="filled" @click="del_other(item, index)" class="delIcon"/>
              </a-col>
            </a-row>
          </div>
        </div>
        <a-button block type="dashed" icon="plus" @click="add_other" class="addBtn_general">添加</a-button>
      </div>
    </div>
    <div class="treeListDiv">
      <div class="titleDiv">
        <div class="title">
          <span>已选设备字段</span>
        </div>
      </div>
      <a-spin :spinning="treeLoading">
        <a-tree
          :draggable="$auth('deviceType.ledgerFieldDrop')"
          :treeData="treeData"
          @dragstart="onStart"
          @drop="onDrop"
        >
          <template slot="custom" slot-scope="item">
            <span>{{ item.dataIndex }}</span>
          </template>
        </a-tree>
      </a-spin>
    </div>
  </div>
</template>

<script>
import {
  getBaseField, saveTypeField
} from '@/api/deviceType'
import { saveAssetTypeField } from '@/api/assetHeadManage'

export default {
  name: 'ParameterConfiguration',
  props: ['fieldListData', 'treeData'],
  computed: {
    deviceTypeStatus () {
      return this.$store.state.deviceType.deviceTypeStatus
    }
  },
  data () {
    return {
      ledgerForm: this.$form.createForm(this, { name: 'featureConfiguration' }),
      btnLoading: false,
      treeLoading: false,
      spinLoading: false,
      type: 'edit',
      unfold: false,
      typeList: [
        {
          label: '基础参数',
          value: 2
        },
        {
          label: '特性',
          value: 4
        }
        // {
        //   label: '自定义参数',
        //   value: 3
        // }
      ],
      // 多选列表
      plainOptions: [],
      // 多选
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      // 参数特性字段
      parameterCharacteristicsList: [],
      parameterCharacteristicsListOriginal: []
    }
  },
  watch: {
    parameterCharacteristicsList: {
      handler (val) {
        val.forEach((item, index) => {
          this.parameterCharacteristicsListOriginal[index].type = item.type
        })
      },
      deep: true
    }
  },
  methods: {
    // 设置表单
    initTableData (data) {
      this.parameterCharacteristicsList = JSON.parse(JSON.stringify(data))
      this.parameterCharacteristicsListOriginal = JSON.parse(JSON.stringify(data))
    },
    // 设置选中的资产基础信息字段
    setCheckList (checkedList) {
      this.checkedList = checkedList
    },
    // 获取所有资产基础信息字段
    getBaseField () {
      const data = {
        pCode: 'equipment_field'
      }
      this.spinLoading = true
      getBaseField(data).then(res => {
        if (res.status === 0) {
          this.plainOptions = res.data.map(item => {
            return {
              label: item.name,
              value: item.code
            }
          })
          this.spinLoading = false
        } else {
          this.$message.error(res.info.message)
          this.spinLoading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.spinLoading = false
      })
    },
    // 多选回调
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    // 是否全选
    whetherToSelectAll (bool) {
      Object.assign(this, {
        checkedList: bool ? this.plainOptions.map(item => { return item.value }) : []
      })
    },
    // 改变类型
    changeType (item, index) {
      item.paramOrFeature = undefined
      item.field = undefined
      item.fieldList = []
      this.parameterCharacteristicsListOriginal[index] = JSON.parse(JSON.stringify(item))
    },
    // 参数/特性改变
    changeFeature (value, item, index) {
      item.field = undefined
      item.fieldList = this.fieldListData.paramList[value].children
      this.parameterCharacteristicsListOriginal[index] = JSON.parse(JSON.stringify(item))
    },
    // 增加其他参数
    add_other () {
      this.parameterCharacteristicsList.push({
        type: undefined,
        paramOrFeature: undefined,
        field: undefined
      })
      this.parameterCharacteristicsListOriginal.push({
        type: undefined,
        paramOrFeature: undefined,
        field: undefined
      })
      const div = document.getElementsByClassName('ledgerFieldDiv')[0]
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
    },
    // 判断删除其他参数
    del_other (item, index) {
      this.parameterCharacteristicsList.splice(index, 1)
      this.parameterCharacteristicsListOriginal.splice(index, 1)
    },
    // 特性选择(用于判断当前列表中是否有该特性，有则不可选择，并且提示该字段已选择，请选择其他字段)
    changeParamOrFeature (value, item) {
      this.parameterCharacteristicsListOriginal.find((i, index) => {
        if (i.type === 4) {
          if (i.paramOrFeature === value) {
            this.$message.error('该字段已选择，请选择其他字段')
            item.paramOrFeature = undefined
          } else {
            i.paramOrFeature = this.parameterCharacteristicsList[index].paramOrFeature
          }
        }
      })
    },
    // 基础参数选择
    changeField (value, item) {
      this.parameterCharacteristicsListOriginal.find((i, index) => {
        if (i.type === 2) {
          if (i.field === value) {
            this.$message.error('该字段已选择，请选择其他字段')
            item.field = undefined
          } else {
            i.field = this.parameterCharacteristicsList[index].field
          }
        }
      })
    },
    // 参数设置保存
    async handleSubmit () {
      this.btnLoading = true
      const typeFieldList = []
      this.checkedList.forEach(item => {
        const data = {
          dataIndex: item,
          type: 1
        }
        typeFieldList.push(data)
      })
      try {
        this.parameterCharacteristicsList.forEach(item => {
          if (item.type) {
            if (item.type === 2) {
              if (item.field) {
                // 基础参数
                const data = {
                  dataIndex: item.field,
                  type: 2,
                  pcode: this.fieldListData.paramList[item.paramOrFeature].typeCode
                }
                typeFieldList.push(data)
              } else {
                throw new Error('请填写完整参数特性字段')
              }
            } else if (item.type === 3) {
              if (item.field) {
                // 自定义参数
                const data = {
                  dataIndex: item.field,
                  type: 3
                }
                typeFieldList.push(data)
              } else {
                throw new Error('请填写完整参数特性字段')
              }
            } else if (item.type === 4) {
              if (item.paramOrFeature) {
                // 特性
                const data = {
                  dataIndex: item.paramOrFeature,
                  type: 4
                }
                typeFieldList.push(data)
              } else {
                throw new Error('请填写完整参数特性字段')
              }
            }
          } else {
            throw new Error('请填写完整参数特性字段')
          }
        })
      } catch (error) {
        this.$message.error('请填写完整参数特性字段')
        this.btnLoading = false
        return
      }
      const params = {
        code: this.deviceTypeStatus.data.code,
        typeFieldList: typeFieldList,
        type: 1
      }
      saveTypeField(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.$emit('getTabData', {
            id: this.deviceTypeStatus.data.id,
            typeId: this.deviceTypeStatus.data.id,
            typeCode: this.deviceTypeStatus.data.code
          })
          this.btnLoading = false
        } else {
          this.$message.error(res.info.message)
          this.btnLoading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.btnLoading = false
      })
    },

    // 拖拽
    onDrop (info) {
      let realPos
      const that = this
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.treeData]
      const dragPos = info.dragNode.pos.split('-')
      // 判断是否在同一个父节点下移动
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1)
        dragObj = item
      })
      if (info.dropToGap) {
        let ar
        let i
        loop(data, dropKey, (item, index, arr) => {
          ar = arr
          i = index
        })
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj)
        } else {
          ar.splice(i + 1, 0, dragObj)
        }
        let showTitle = ''
        showTitle = `您确定调整【${info.dragNode.dataRef.title}】的顺序为第【${realPos}】位吗?`
        this.$confirm({
          title: showTitle,
          onOk () {
            // 调用接口
            that.drop(data)
          },
          onCancel () {}
        })
      }
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
      this.dragId = info.node.dataRef.id
    },
    // 菜单拖拽
    async drop (data) {
      const typeFieldList = []
      data.forEach(item => {
        if (item.type === 1) {
          // 基础信息
          const data = {
            dataIndex: item.field,
            type: 1
          }
          typeFieldList.push(data)
        } else if (item.type === 2) {
          // 基础参数
          const data = {
            dataIndex: item.field,
            type: 2,
            pcode: item.pcode
          }
          typeFieldList.push(data)
        } else if (item.type === 3) {
          // 自定义参数
          const data = {
            dataIndex: item.field,
            type: 3
          }
          typeFieldList.push(data)
        } else if (item.type === 4) {
          // 特性
          const data = {
            dataIndex: item.field,
            type: 4
          }
          typeFieldList.push(data)
        }
      })
      const params = {
        code: this.deviceTypeStatus.data.code,
        typeFieldList: typeFieldList,
        type: 1
      }
      this.setTreeLoading(true)
      saveTypeField(params).then(res => {
        if (res.status === 0) {
          this.$message.success('操作成功!')
          this.$emit('getLedgerFieldDetail', this.deviceTypeStatus.data.id, this.deviceTypeStatus.data.code, false)
        } else {
          this.$message.error(res.info.message)
          this.setTreeLoading(false)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.setTreeLoading(false)
      })
    },
    setTreeLoading (bol) {
      this.treeLoading = bol
    }
  }
}
</script>

<style scoped lang="less">
.parameterConfiguration {
  height: calc(100% - 45px);
  overflow: hidden;
  border-top: 1px solid #DDDDDD;
  padding-top: 11px;
  display: flex;
  .saveBtn {
    margin-bottom: 12px;
  }
  .ledgerFieldDiv {
    width: calc(100% - 300px);
    border-right: 1px solid #DDDDDD;
    overflow-y: auto;
    padding-right: 12px;
  }
  .treeListDiv {
    width: 300px;
    height: 100%;
    padding: 16px 12px;
    /deep/.ant-spin-nested-loading {
      height: calc(100% - 26px);
    }
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
    margin-right: 12px;
  }
  .upOrDownIcon {
    margin-right: 20px;
    cursor: pointer;
  }
  .checkAll {
    margin-right: 12px;
  }
}
.otherParameters {
  margin-top: 8px;
  margin-bottom: 8px;
  .generalParameter {
    /deep/.ant-col-6 {
      padding-left: 12px;
      .ant-form-item-children {
        display: flex;
        flex-direction: row;
        align-items: center;
        .ant-select {
          width: calc(100% - 28px);
          margin-right: 8px;
        }
        .delIcon {
          font-size: 20px;
          color: red;
        }
      }
    }
  }
}
.addBtn_general {
  width: 100%;
  /deep/.anticon {
    color: #1791FF;
  }
}
.other-data{
  position: relative;
  height: calc(100% - 44px);
  .action-btn{
    position: absolute;
    right: 10px;
    top: -36px;
    display: flex;
    .btn{
      margin-left: 10px;
    }
  }
  .item-label{
    margin: 0 0 12px 0 !important;
    background: #F5F5F5;
    .ant-col {
      padding: 10px 8px;
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      border-right: 1px solid #DDDDDD;
    }
    .ant-col:nth-child(1) {
      border-left: 1px solid #DDDDDD;
    }
    .anticon{
      color: #1791FF;
      font-size: 14px;
      margin-left: 9px;
      margin-right: 9px;
    }
    .anticonTooltip{
      color: #1791FF;
      font-size: 12px;
    }
  }
  .dataInputDiv {
    height: calc(100% - 70px);
    /deep/.ant-col {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .delIcon {
      margin-left: 12px;
    }
  }
  .item-data{
    width: 100%;
    margin-bottom: 12px;
    .anticon{
      color: #E73B3B;
      font-size: 20px;
    }
  }
}
.fontWeight {
  font-weight: bold;
}
/deep/.ant-modal-confirm-title {
  font-weight: bold;
  font-size: 16px;
}
.ant-checkbox-group-height {
  height: calc(28px * 5);
  overflow: hidden;
}
.height100 {
  height: 100%;
}
/deep/.ant-checkbox-group-item {
  width: calc(100% / 4);
  margin: 0 0 10px 0 !important;
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
  min-width: calc(100% - 24px);
}
/deep/.ant-select-dropdown-menu-item-disabled {
  color: rgb(191, 191, 191) !important;
}
</style>
